import React from 'react';
import FullCalendar from '@fullcalendar/react';
import { Box, Tooltip, Typography } from '@material-ui/core';
import { formatDate } from '@fullcalendar/core';
import { getTextWidth } from 'utils';
import { useTheme } from '@material-ui/core/styles';
import frLocale from '@fullcalendar/core/locales/fr';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import useStyles from './styles';

const eventRender = (event, config, classes, theme) => {
  return (
    <div className={classes.eventContainer}>
      <div
        className={classes.eventTitleContainer}
        style={
          config
            ? {
                flexDirection: 'column',
              }
            : {
                alignItems: 'center',
              }
        }
      >
        {!config && (
          <div
            className={classes.coloredDot}
            style={{
              border: '4px solid ' + event.backgroundColor,
            }}
          />
        )}
        <div className={classes.eventTime}>
          {formatDate(event.start, { hour: '2-digit', minute: '2-digit', hour12: false })}
          {config && ' - ' + formatDate(event.end, { hour: '2-digit', minute: '2-digit', hour12: false })}
        </div>
        {getTextWidth(event.title, theme.typography.h1.font) >= 160 ? (
          <Tooltip title={event.title}>
            <Typography noWrap className={classes.eventTitle}>
              {event.title}
            </Typography>
          </Tooltip>
        ) : (
          <Typography className={classes.eventTitle}>{event.title}</Typography>
        )}
      </div>
      {!config && <div className={classes.eventCapacity}>{event.extendedProps.activityStatus}</div>}
    </div>
  );
};

const StyledAgenda = React.forwardRef(
  (
    {
      transferOpen = false,
      config = false,
      allowEvent = () => true,
      eventClassNames = [],
      headerToolbar = {
        left: 'prev,next today',
        center: 'title',
        right: '',
      },
      ...rest
    },
    ref,
  ) => {
    const classes = useStyles();
    const theme = useTheme();
    return (
      <Box style={{ display: !!transferOpen ? 'none' : 'block' }} className={classes.agenda}>
        <FullCalendar
          ref={ref}
          height="auto"
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          locale={frLocale}
          headerToolbar={headerToolbar}
          titleFormat={{
            year: 'numeric',
            month: 'long',
          }}
          forceEventDuration={true}
          eventAllow={allowEvent}
          allDaySlot={false}
          eventDurationEditable={false}
          eventTextColor="white"
          slotMinTime="07:00"
          slotMaxTime="23:00"
          eventClassNames={eventClassNames}
          eventContent={({ event }) => eventRender(event, config, classes, theme)}
          {...rest}
        />
      </Box>
    );
  },
);

export default StyledAgenda;
